import React, { useState } from "react";
import {
  Popconfirm,
  Transfer,
  Input,
  Card,
  Collapse,
  Button,
  Row,
  Col,
  Radio,
  Popover,
} from "antd";
import deleteIcon from "../../img/delete.svg";
import compareStringsWithPoints from "../../../../lib/utils/compareStringWithPoints";

const { Panel } = Collapse;

const TitlePanel = (item, clickHandler) => (
  <Radio
    onClick={(e) => {
      e.stopPropagation();
      clickHandler(item, e.target.checked);
    }}
    value={item.id}
  >
    <span style={{ whiteSpace: "break-spaces" }}>{item.alias}</span>
  </Radio>
);

const styles = {
  input: {
    marginBottom: "9px",
  },
  card: {
    height: "60vh",
    overflow: "auto",
  },
  cardBody: {
    padding: "0",
    overflow: "auto",
  },
  transfer: {
    height: "60vh",
  },
  transferList: {
    width: "100%",
    height: "60vh",
  },
  radioGroup: {
    width: "100%",
  },
  permissionItem: {
    margin: "16px",
    whiteSpace: "normal",
  },
};

function RoleEditingTab(props) {
  const {
    editedTargetKeys,
    handleEditRoleName,
    handleEditPermissions,
    handleChangeRoleForEdit,
    editedRoleName,
    handleEditRole,
    roles,
    permissions,
    handleDeleteRole,
    selectedRoleForEdit,
  } = props;
  const [isDisabledButton, setIsDisabledButton] = useState(true);
  const mockData = permissions.map((item) => ({
    key: item.id,
    id: item.id,
    alias: item.alias,
    dsc: item.dsc,
  }));

  const renderRoleCard = () => {
    const renderCardTitle = () => (
      <h3>
        Ролей в системе:
        {roles.length}
      </h3>
    );
    return (
      <Card style={styles.card} bodyStyle={styles.cardBody} title={renderCardTitle()}>
        <Radio.Group style={styles.radioGroup}>
          <Collapse expandIconPosition="right" ghost>
            {roles.map((item) => (
              <Panel header={TitlePanel(item, handleChangeRoleForEdit)} key={item.id}>
                {item.includedPermissions
                  .sort((a, b) => compareStringsWithPoints(a.alias, b.alias))
                  .map((permission) => (
                    <div style={styles.permissionItem} key={permission.id}>
                      <i className="included" />
                      <div>{permission.alias}</div>
                    </div>
                  ))}
              </Panel>
            ))}
          </Collapse>
        </Radio.Group>
      </Card>
    );
  };

  const renderTransfer = () => {
    const handleChange = (nextTargetKeys) => {
      handleEditPermissions(nextTargetKeys);
      setIsDisabledButton(false);
    };

    return (
      <Transfer
        dataSource={mockData}
        titles={["Все привилегии", "Привилегии новой роли"]}
        targetKeys={editedTargetKeys}
        onChange={handleChange}
        showSearch
        filterOption={(inputValue, item) =>
          item.alias.toLowerCase().includes(inputValue.toLowerCase()) ||
          item.dsc.toLowerCase().includes(inputValue.toLowerCase())
        }
        style={styles.transfer}
        listStyle={styles.transferList}
        render={(item) => <Popover content={item.dsc}>{item.alias}</Popover>}
      />
    );
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={8}>
          {renderRoleCard()}
          <Popconfirm
            className="row_buttons"
            title="Вы действительно хотите удалить выбранную роль?"
            okText="Да"
            cancelText="Нет"
            onConfirm={handleDeleteRole}
          >
            <img src={deleteIcon} style={{ float: "right" }} />
          </Popconfirm>
        </Col>
        <Col flex="1">
          <Input
            value={editedRoleName}
            onChange={(e) => handleEditRoleName(e.target.value)}
            placeholder="Введите название"
            style={styles.input}
          />
          {renderTransfer()}
        </Col>
      </Row>
      <Row className="row_buttons" justify="end">
        <Button
          disabled={!selectedRoleForEdit}
          onClick={() => {
            handleEditRole();
            setIsDisabledButton(true)
          }}
          type="primary"
        >
          Сохранить
        </Button>
      </Row>
    </>
  );
}

export default RoleEditingTab;
